export function getUser(userId, users) {
  if (users !== undefined) {
    if (userId in users) {
      return users[userId];
    }
  }
  return {};
}

export function getUserName(userId, users) {
  const user = getUser(userId, users);
  if (user) {
    if (user.first_name && user.last_name) {
      return user.first_name + ' ' + user.last_name;
    } else if (user.first_name) {
      return user.first_name;
    } else if (user.last_name) {
      return user.last_name;
    }
  }
  return userId;
}